import Simple from 'layouts/simple'
import React from 'react'
import { PoliticasWrapper } from 'styles/global'

const PoliticaPrivacidade = () => {
  return (
    <>
      <Simple>
        <PoliticasWrapper>
          <div className="container">
            <h1 className="titulo">
              POLÍTICA DE PRIVACIDADE DO WEBSITE DA EMPRESA
            </h1>

            <div className="d-flex flex-column gap-4">
              <section>
                <p>
                  A&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , reconhece a importância de proteger a privacidade de todos
                  os usuários de seu website. Trazemos aqui as informações
                  acerca de como coletamos e utilizamos seus dados pessoais
                  quando você acessa nosso website. Nós nunca venderemos seus
                  dados, nem deixaremos que terceiros tenham acesso aos seus
                  dados sem a devida autorização, conforme esclarecemos nesta
                  política.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">Quem somos?</h2>
                <p>
                  A&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , pessoa jurídica de direito privado inscrita no CNPJ sob o
                  nº. <strong>04.380.132/0001-47</strong>, tem sua matriz
                  instalada na Av. Antônio Diederichsen, nº 400, sala 16, Jardim
                  América, na cidade de Ribeirão Preto/SP, CEP: 14.020-250. Ela
                  é a principal controladora dos dados pessoais que trafegam por
                  este website.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">Quais dados coletamos?</h2>
                <p>
                  Quando você utiliza nosso website para acessar nossos
                  serviços, coletamos seus dados de identificação (RG, CPF,
                  CTPS, data de nascimento, estado civil, nome cônjuge,
                  nacionalidade, gênero) contato (telefone, celular, e-mail),
                  escolaridade, filiação, localização (endereço, bairro, CEP,
                  cidade e Estado), informações bancárias (renda, tipo de conta,
                  agência e banco) conforme você preencha os campos apropriados
                  em nosso website para utilizar as funcionalidades disponíveis.
                  Também coletamos as comunicações feitas conosco, além de nome
                  de usuário e credenciais de login no caso de ser criada uma
                  conta de usuário em nosso website. Além dessas informações,
                  nosso website também coleta dados técnicos de acesso e
                  informações de seu comportamento de navegação no site, por
                  meio de cookies (veja abaixo).
                </p>
              </section>

              <section>
                <h2 className="subtitulo">
                  Para quais finalidades usamos seus dados?
                </h2>
                <p>
                  Coletamos informações de identificação pessoal e de contato
                  dos usuários para as finalidades de gestão de contas de
                  usuários, estabelecer comunicação com os usuários e visitantes
                  do site, retornar contato e realizar a prestação de nossos
                  serviços, quais sejam, simulações de crédito e efetivações de
                  propostas juntos as Instituições Financeiras parceiras da
                  RIBERCRED. Esses dados serão mantidos conosco pelo tempo
                  necessário para atendermos a cada uma dessas finalidades.
                </p>
                <p>
                  Sempre que você utilizar o website e os serviços
                  disponibilizados a você via web, usaremos seus dados para
                  identificação e validação de acesso, possibilitando que
                  utilize os serviços de forma segura, de modo a aumentarmos a
                  proteção contra fraudes e danos aos usuários e a terceiros.
                </p>
                <p>
                  As diversas funcionalidades e serviços disponibilizados em
                  domínios e websites específicos ou dedicados da&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , C.N.P.J./MF sob nº <strong>04.380.132/0001-47</strong>&nbsp;
                  estarão sujeitas às próprias políticas, que podem ser
                  encontradas em cada site.
                </p>
                <p>
                  Também guardamos registros de todos os acessos ao website e ao
                  app pelo <strong>prazo de 6 meses da coleta</strong>, conforme
                  exigido pelo Marco Civil da Internet (Lei nº 12.965/2014).
                </p>
              </section>

              <section>
                <h2 className="subtitulo">Quais são os cookies utilizados?</h2>
                <p>
                  Quando você acessa nosso website, seu computador recebe alguns
                  “cookies”, ou seja, arquivos de texto por meio dos quais
                  determinadas informações são coletadas e armazenadas
                  automaticamente por nós e pelas empresas com as quais
                  trabalhamos.
                </p>
                <p>
                  Nosso website utiliza cookies próprios para coletar dados de
                  seu dispositivo e sistema de modo a mantê-lo conectado, e para
                  que o website seja apresentado da maneira mais adequada e
                  otimizada à sua visualização. Esses cookies expiram&nbsp;
                  <strong>06 meses.</strong>
                </p>
                <p>
                  Também utilizamos cookies e metatags do Google Analytics para
                  analisar seu comportamento enquanto usuário de nosso website e
                  app, de modo que possamos identificar links pouco utilizados,
                  dificuldades de navegação, funções pouco amigáveis, entre
                  outros problemas para a experiência de nossos clientes no
                  nosso website. Esses cookies expiram no tempo definido pelas
                  empresas responsáveis, e temos acesso apenas a dados sem
                  identificação (i.e. anonimizados), que são suficientes para
                  nossas análises.
                </p>
                <p>
                  Nossas páginas com funcionalidades relativas à contratação de
                  serviços, fazem uso de cookies de redes sociais e serviços de
                  relacionamento com clientes para identificar a origem do
                  tráfego e taxa de conversão, assim como para nos possibilitar
                  a realização de estatísticas e estudos. O uso desses cookies
                  será restrito a essas hipóteses.
                </p>
                <p>
                  Seu navegador pode ser configurado para recusar o recebimento
                  de cookies e possui funções para removê-los a qualquer
                  momento. Verifique as opções e ferramentas disponíveis no
                  respectivo menu do seu navegador.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">
                  Como tratamos os seus dados pessoais?
                </h2>
                <p>
                  Os dados coletados se restringem ao mínimo necessário para a
                  realização dos propósitos indicados, conforme constar nos
                  formulários e documentos que forem preenchidos. Esses dados
                  serão guardados por nós durante todo o relacionamento com você
                  e, depois de seu término, pelo tempo necessário para a defesa
                  de nossos direitos e o cumprimento das obrigações legais e
                  regulatórias a que estamos sujeitos.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">Como guardamos os seus dados?</h2>
                <p>
                  Seus dados são mantidos em nossos servidores em nuvem
                  contratadas com empresas localizadas no exterior, com
                  datacenter situados no Brasil, mediante contrato adequado para
                  a operação de seus dados pessoais de forma segura e
                  responsáveis.
                </p>
                <p>
                  Tomamos as precauções necessárias para evitar a perda e o
                  vazamento de seus dados e controlamos o acesso às informações
                  que temos sobre você pelo uso de medidas técnicas e de gestão
                  adequadas para a sensibilidade do tipo de informações que
                  controlamos.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">
                  Quem mais tem acesso a seus dados?
                </h2>
                <p>
                  A&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , C.N.P.J./MF sob nº <strong>04.380.132/0001-47</strong>, pode
                  compartilhar seu website com terceiros, na medida necessária
                  para atingir os fins específicos de nosso website, quais
                  sejam:
                </p>
                <ul>
                  <li>
                    empresa responsável pelo desenvolvimento e sustentação do
                    site.
                  </li>
                  <li>
                    empresas de tecnologia responsáveis pelos cookies utilizados
                    para análise de uso do website.
                  </li>
                  <li>plataformas de gerenciamento do website.</li>
                  <li>empresas de serviços de operação de dados em nuvem.</li>
                  <li>aplicações de comunicação via internet.</li>
                </ul>
                <p>
                  As empresas terceiras que fornecem funcionalidades especiais a
                  nosso website por meio de suas aplicações próprias poderão
                  coletar e utilizar dados pessoais conforme suas próprias
                  políticas de privacidade. Recomendamos que verifiquem as
                  políticas de privacidade providenciados no momento da
                  utilização dessas funcionalidades.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">
                  Quais são os seus direitos com relação à coleta e uso dos seus
                  dados?
                </h2>
                <p>
                  Nós garantimos os seguintes direitos aos usuários com relação
                  à coleta e uso de dados por meio de nosso website, em adição a
                  outros direitos previstos na legislação aplicável:
                </p>
                <ul>
                  <li>
                    a confirmação de existência de tratamento de seus dados
                    pessoais por nós.
                  </li>
                  <li>o acesso aos dados detidos por essa entidade.</li>
                  <li>
                    a correção de eventuais dados incompletos, inexatos ou
                    desatualizados.
                  </li>
                  <li>
                    o bloqueio, a eliminação ou a anonimização de dados
                    desnecessários, excessivos ou tratados em desconformidade
                    com a legislação, bem como oposição ao tratamento desses
                    dados nas mesmas hipóteses.
                  </li>
                  <li>
                    portabilidade dos seus dados pessoais a outra empresa, na
                    medida em que seja exigida por regulamentos oficiais sobre o
                    assunto.
                  </li>
                  <li>
                    a eliminação, quando requerida, dos dados pessoais coletados
                    mediante seu consentimento, na forma da legislação
                    aplicável.
                  </li>
                  <li>
                    informação das entidades públicas e privadas com as quais
                    houve uso compartilhado de seus dados.
                  </li>
                  <li>
                    informação sobre a possibilidade de não fornecer seu
                    consentimento e sobre as consequências da negativa, nos
                    casos em que seus dados forem coletados e tratados mediante
                    consentimento.
                  </li>
                  <li>
                    a revogação do seu consentimento para coleta e tratamento de
                    dados nestes mesmos casos.
                  </li>
                </ul>
                <p>
                  Seus direitos poderão ser exercidos mediante contato feito
                  através dos nossos canais de atendimento listados abaixo. Caso
                  esteja insatisfeito, a legislação brasileira garante a você a
                  possibilidade de levar sua reclamação à ANPD - Autoridade
                  Nacional de Proteção de Dados Pessoais.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">
                  Como nossas práticas de privacidade poderão ser alteradas?
                </h2>
                <p>
                  Nossas políticas e práticas quanto à privacidade e proteção de
                  dados são objeto de constante revisão e atualização para
                  adequar-se aos mais elevados padrões nacionais e
                  internacionais, podendo ser alteradas a qualquer tempo. Nossas
                  políticas e avisos de privacidade serão atualizados em nosso
                  website/app para refletir tais alterações e suas versões mais
                  recentes serão publicadas nesta página.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">Como entrar em contato conosco?</h2>
                <p>
                  Em conformidade com o art. 41 da Lei nº 13.709/2018 – Lei
                  Geral de Proteção de Dados Pessoais (LGPD) – e com a Resolução
                  CD/ANPD nº 18/2024, a&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , pessoa jurídica de direito privado, inscrita no CNPJ sob o
                  nº <strong>04.380.132/0001-47</strong>, com sede na Av.
                  Antônio Diederichsen, nº 400, sala 16, Jardim América,
                  Ribeirão Preto/SP, CEP 14.020-250, informa que contratou como
                  Encarregado pelo Tratamento de Dados Pessoais (“Encarregado”)
                  a empresa:
                </p>
                <p>
                  <strong>MOORE PRISMA CONSULTORES LTDA</strong>, inscrita no
                  CNPJ sob o nº&nbsp;
                  <strong>04.222.143/0001-07.</strong>
                </p>
                <p>
                  A Sra. Ana Cristina Oliveira Mahle, atua como representante da
                  Moore nas comunicações com os titulares de dados pessoais e
                  com a Autoridade Nacional de Proteção de Dados (ANPD),
                  conforme previsto na legislação. Para quaisquer dúvidas acerca
                  desta Política de Privacidade, informações sobre os dados que
                  possuímos a seu respeito, ou qualquer outra solicitação ou
                  reclamação relacionada à sua privacidade e ao exercício dos
                  seus direitos previstos na LGPD, entre em contato com nosso
                  Encarregado pelos seguintes canais:
                </p>
                <div className="contato">
                  <p>
                    <strong>E-mail:</strong> dpo@ribercred.com.br
                  </p>
                  <p>
                    <strong>Correspondência postal:</strong>
                  </p>
                  <p>A/C Encarregado pelo Tratamento de Dados Pessoais</p>
                  <p>
                    Av. Antônio Diederichsen, nº 400, sala 16, Jardim América
                  </p>
                  <p>Ribeirão Preto/SP – CEP 14.020-250</p>
                </div>

                <p>
                  As solicitações serão tratadas com confidencialidade,
                  transparência e dentro dos prazos legais estabelecidos pela
                  LGPD.
                </p>
              </section>

              <section className="pt-4">
                <p className="text-sm text-muted-foreground italic">
                  Esta política foi atualizada em&nbsp;
                  <span className="data-atualizacao">12/03/2025.</span>
                </p>
              </section>
            </div>
          </div>
        </PoliticasWrapper>
      </Simple>
    </>
  )
}

export default PoliticaPrivacidade
